import { Injectable } from '@angular/core';
import { Assembly } from 'src/app/models/assembly.model';
import { Category } from 'src/app/models/category.model';
import { Observable, of } from 'rxjs';
import { learningCategories } from './learning-categories';
import assembliesJSON from 'src/assets/learning/data/catalog.json';

@Injectable({
  providedIn: 'root'
})
export class LearningAssembliesService {
  assemblies: Assembly[] = [];

  constructor(
  ) {

   }

  loadAssemblies(): Observable<Assembly[]> {
    const categories = learningCategories;
    this.assemblies = assembliesJSON
      .filter(assembly => {
        const category = categories.find(category => category.CategoryID === assembly.CategoryID);
        return category !== undefined;
      })
      .map(assembly => {
        let category = categories.find(category => category.CategoryID === assembly.CategoryID)!; // Non-null assertion
        return {
          Name: assembly.Name,
          Description: assembly.Description,
          Type: assembly.Type,
          AID: assembly.AID,
          CategoryID: assembly.CategoryID,
          AssemblyPriceTable: assembly.AssemblyPriceTable.map(price => ({
            ...price,
            DateUpdated: new Date(price.DateUpdated) // Convert string to Date
          })),
          isDummy: assembly.isDummy,
          AssemblyPrice: 0,
          Categories: category,
          FID: 0
        }
      });
      return of(this.assemblies)
  }
}
